import React, { useEffect, useState } from 'react';
import { SafeAreaView, View, Text, ScrollView, TouchableOpacity, StyleSheet, Platform, ImageBackground } from 'react-native';
import { useNavigate } from 'react-router-dom';
import { ModuleHeader } from '@cubemeet/ui';
import type { RootState } from '../store';
import { useSelector, useDispatch } from 'react-redux';

const cities = [
  { key: 'tokyo', label: '东京', imageUrl: '/assets/images/destinations/tokyo.jpg' },
  { key: 'osaka', label: '大阪', imageUrl: '/assets/images/destinations/osaka.jpg' },
  { key: 'kyoto', label: '京都', imageUrl: '/assets/images/destinations/kyoto.jpg' },
  { key: 'taipei', label: '台北', imageUrl: '/assets/images/destinations/taibei.jpg' },
  { key: 'hongkong', label: '香港', imageUrl: '/assets/images/destinations/hongkong.jpg' },
  { key: 'beijing', label: '北京', imageUrl: '/assets/images/destinations/beijing.jpg' },
  { key: 'shanghai', label: '上海', imageUrl: '/assets/images/destinations/shanghai.jpg' },
  { key: 'macau', label: '澳門', imageUrl: '/assets/images/destinations/macau.jpg' },
  { key: 'seoul', label: '首尔', imageUrl: '/assets/images/destinations/seoul.jpg' },
  { key: 'bangkok', label: '曼谷', imageUrl: '/assets/images/destinations/bangkok.jpg' },
  { key: 'singapore', label: '新加坡', imageUrl: '/assets/images/destinations/singapore.jpg' },
  { key: 'kuala-lumpur', label: '吉隆坡', imageUrl: '/assets/images/destinations/Kuala-Lumpur.jpg' },
];

const CityIndexPage: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const authState = useSelector((state: RootState) => (state as any)?.auth ?? {}) as any;
  const isAuthenticated = Boolean(authState?.isAuthenticated);

  return (
    <SafeAreaView style={styles.safeArea}>
      <ModuleHeader moduleType="travel" title="城市指南" topInset={0} showBackButton onBack={() => { if (typeof window !== 'undefined') window.history.back(); }} />
      <ScrollView contentContainerStyle={styles.container}>
        <View style={styles.inner}>
          <Text style={styles.intro}>选择城市以查看当地推荐与游记</Text>
          <View style={styles.grid}>
            {cities.map((c) => (
              <TouchableOpacity key={c.key} style={styles.card} onPress={() => navigate(`/city/${c.key}`)}>
                <ImageBackground 
                  source={{ uri: c.imageUrl }} 
                  style={styles.cardBackground}
                  imageStyle={styles.cardImage}
                >
                  <View style={styles.cardOverlay}>
                    <Text style={styles.cardText}>{c.label}</Text>
                  </View>
                </ImageBackground>
              </TouchableOpacity>
            ))}
          </View>
        </View>
      </ScrollView>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  safeArea: { flex: 1, backgroundColor: '#F3F4F6' },
  container: { 
    padding: 20, 
  },
  inner: { maxWidth: 600, width: '100%', alignSelf: 'center' },
  intro: { fontSize: 16, color: '#374151', marginBottom: 12 },
  grid: { flexDirection: 'row', flexWrap: 'wrap', gap: 12 },
  card: { 
    width: '48%', 
    aspectRatio: 16/9, // 使用16:9比例，与首页热门景点保持一致
    borderRadius: 12, 
    marginBottom: 12, 
    overflow: 'hidden', // 确保圆角正确显示
    ...Platform.select({
      web: {
        boxShadow: '0px 2px 4px rgba(0,0,0,0.1)'
      },
      default: {
        elevation: 2, // Android 阴影
        shadowColor: '#000', // iOS 阴影
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.1,
        shadowRadius: 4,
      },
    }),
  },
  cardBackground: {
    flex: 1,
    justifyContent: 'flex-end', // 文字显示在底部
  },
  cardImage: {
    borderRadius: 12, // 图片也需要圆角
  },
  cardOverlay: {
    paddingVertical: 8,
    paddingHorizontal: 12,
    alignItems: 'flex-start', // 文字左对齐
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
  },
  cardText: { 
    fontSize: 16, 
    fontWeight: '700', 
    color: '#FFFFFF', // 白色文字
    textAlign: 'left',
    // 使用 Platform.select 在 web 上提供 CSS 字符串形式的 textShadow，避免 react-native-web 关于 textShadow* 的弃用警告
    ...(Platform.select ? Platform.select({ web: { textShadow: '1px 1px 2px rgba(0,0,0,0.8)' }, default: { textShadowColor: 'rgba(0, 0, 0, 0.8)', textShadowOffset: { width: 1, height: 1 }, textShadowRadius: 2 } }) : { textShadowColor: 'rgba(0, 0, 0, 0.8)', textShadowOffset: { width: 1, height: 1 }, textShadowRadius: 2 }),
  },
});

export default CityIndexPage;
